// @flow
import { get } from "lodash";

import { betColumnsWPS, betWPS, WagerTypesMap } from "@fdr/types/WagerTypes";
import type { RaceWagerType } from "@tvg/types/Race";

export const multiLegWagerTypes = [
  "DB",
  "P3",
  "P4",
  "P5",
  "P6",
  "P7",
  "P8",
  "P9"
];

export const isHongKongRaces = (code: string) =>
  code.includes("HKS") || code.includes("HKH");

export const isSelectionsWPS = (wagerTypeCode: string) =>
  Object.keys(betColumnsWPS).includes(wagerTypeCode);

export const getSelectionsWPS = (
  wagerTypeCode: string,
  selections: Array<Array<string>>
): Array<Array<string>> => {
  if (isSelectionsWPS(wagerTypeCode) && selections.length === 1) {
    const betColumnsWagerType = betColumnsWPS[wagerTypeCode];
    const selectionsWPS = [[], [], []].map((el, idx) =>
      betColumnsWagerType.includes(idx) ? [...selections[0]] : el
    );

    return selectionsWPS;
  }

  return selections;
};

export const findWagerType = (
  wagerType: string | number,
  wagerTypes: Array<RaceWagerType>
): ?RaceWagerType =>
  wagerTypes.find((wt) =>
    isNaN(wagerType) ? wt.type.code === wagerType : wt.type.id === +wagerType
  );

export const findCompatibleWagerType = (
  wagerType: string | number,
  wagerTypes: Array<RaceWagerType>
): ?RaceWagerType => {
  let compatibleWagerType: ?RaceWagerType;
  const wagerTypeEntry = Object.values(WagerTypesMap).find((value) =>
    isNaN(wagerType)
      ? get(value, "code") === wagerType
      : get(value, "id") === +wagerType
  );

  if (wagerTypeEntry && get(wagerTypeEntry, "code") in betWPS) {
    compatibleWagerType = wagerTypes.find((wt) =>
      // $FlowFixMe
      betWPS[wagerTypeEntry.code]?.every((betTypeId) =>
        // $FlowFixMe
        (betWPS[wt.type.code] || []).includes(betTypeId)
      )
    );
  }

  return compatibleWagerType;
};

export const getSelectionsFromParams = (
  params: URLSearchParams
): Array<Array<string>> => {
  // handle selectedRunner
  if (params.has("selectedRunner")) {
    return [[params.get("selectedRunner")]];
  }
  // handle selection model
  const selectionsParams: Array<string> = Array.from(params.keys()).filter(
    (key) => key.startsWith("s") && !isNaN(key[1])
  );

  const selections = selectionsParams
    .sort()
    .map((selection) => params.get(selection).split(","));

  return isSelectionsWPS(params.get("wt"))
    ? getSelectionsWPS(params.get("wt"), selections)
    : selections;
};

export const calcNodeListWidth = (
  nodes: Array<HTMLElement>,
  maxNodeIdx: number = -1,
  offset: number = 0
) => {
  let totalWidth = 0;
  if (nodes) {
    nodes.forEach((node, idx) => {
      if (maxNodeIdx === -1 || idx < maxNodeIdx)
        totalWidth += node.scrollWidth + offset;
    });
  }

  return totalWidth;
};

export default {
  multiLegWagerTypes
};
